export default class FormatarNumeros {
    static formatarNumero(numero: number) {
      if(!numero) return "0";

      return numero.toLocaleString('pt-BR', {
        style: 'decimal',
        currency: 'BRL'
    });
  }

  static formatDate(date: Date){
    if(date){
      const formattedDate = date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
      });
      return formattedDate
    }
    return null;
  }

  static returnExistingFormattedDate(dateString: string){
    if(dateString){
      const currentDate = new Date(dateString);
      return FormatarNumeros.formatDate(currentDate);
    }
    return null;
  }
}
